import { CdkConnectedOverlay, ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DropdownKeyboardDirective } from './dropdown-keyboard.directive';
import { DropdownTriggerDirective } from './dropdown-trigger.directive';

export const DROPDOWN_POSITIONS: ConnectedPosition[] = [
    {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 4
    },
    {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: -4
    },
    {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetY: 4
    },
    {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -4
    }
];

@Component({
    selector: 'tran-dropdown',
    templateUrl: './dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CdkConnectedOverlay, TranslatePipe, DropdownKeyboardDirective]
})
export class DropdownComponent<T extends string> {
    private readonly connectedOverlay = viewChild(CdkConnectedOverlay);
    private readonly keyboardDirective = viewChild(DropdownKeyboardDirective);

    public readonly trigger = input.required<DropdownTriggerDirective>();
    public readonly selectedValue = input.required<T>();
    public readonly values = input.required<T[]>();
    public readonly labelPrefix = input('');

    public readonly valueSelected = output<T>();

    protected readonly positions = DROPDOWN_POSITIONS;

    protected getLabel(value: T): string {
        return this.labelPrefix() ? `${this.labelPrefix()}.${value}` : value;
    }

    protected selectValue(value: T): void {
        this.trigger().close();
        this.valueSelected.emit(value);
    }

    protected onAttach(): void {
        this.connectedOverlay()?.overlayRef.updatePosition();
        requestAnimationFrame(() => {
            this.connectedOverlay()?.overlayRef.updatePosition();
            this.keyboardDirective()?.focusInitial();
        });
    }
}
